<template>
  <div class="payment-container">
    <v-container>
      <v-card flat class="futuristic-card">
        <div class="card-header">
          <h4 class="earth-color" v-if="route !== 'EditStaff'">Add Authorizer</h4>
          <h4 class="earth-color" v-else>Edit Authorizer</h4>
          <div class="title-decoration"></div>
        </div>
        <v-container>
          <v-form @submit.prevent="postStaff()">
            <v-layout row wrap>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="First Name"
                    v-model="staff.first_name"
                    :rules="requiredRules"
                    required
                    class="futuristic-input"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Last Name"
                    v-model="staff.last_name"
                    :rules="requiredRules"
                    required
                    class="futuristic-input"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container fluid>
                  <v-autocomplete
                    label="Department"
                    v-model="staff.department_id"
                    :items="allDepartments"
                    :rules="[v => !!v || 'Item is required']"
                    required
                    item-text="name"
                    item-value="public_id"
                    :loading="$loadingTrue"
                    class="futuristic-input"
                  ></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Phone Number (e.g. 1-347382374)"
                    placeholder="code - number e.g. 1-347382374"
                    v-model="staff.phone_number"
                    :rules="requiredRules"
                    required
                    type="tel"
                    class="futuristic-input"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Email"
                    v-model="staff.email"
                    :rules="requiredRules"
                    required
                    type="email"
                    class="futuristic-input"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg12 md6 sm12 xs12>
                <v-container fluid>
                  <v-btn 
                    depressed 
                    color="#587e27" 
                    block 
                    type="submit" 
                    class="futuristic-btn rounded-btn"
                  >
                    <span v-if="route !== 'EditStaff'">Add Staff</span>
                    <span v-else>Update Staff</span>
                  </v-btn>
                </v-container>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </v-container>
    {{$updateStaff}}
  </div>
</template>

<script>
export default {
  name: 'add-staff',
  data () {
    return {
      route: this.$route.name,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      staff: {
        department_id: '',
        phone_number: '',
        email: '',
        first_name: '',
        last_name: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_departments')
    if (this.$route.name === 'EditStaff') {
      this.$store.dispatch('get_staff', this.$route.params.staff_id)
    }
  },
  methods: {
    postStaff: function () {
      if (this.$route.name === 'EditStaff') {
        this.$store.dispatch('update_staff', this.staff)
      } else {
        this.$store.dispatch('post_staff', this.staff)
      }
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  height: 100%;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rounded-btn {
  border-radius: 24px !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }
  
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }
  
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
}
</style>
